<template>
<CCard>
  <CCardBody>

    <CTabs add-tab-classes="mt-1">
              <CTab>
                  <br>
                <template slot="title">
                  <img src="img/cow (2).svg" style="width:30px;filter: invert(0.5) sepia(1) saturate(5) hue-rotate(-608deg);" /><b>&nbsp;</b>  {{tabs[0]}}
                </template>
                <fixed-plugin></fixed-plugin>
              </CTab>
              <CTab >
                <template slot="title">
                 <CIcon name="cil-settings" style="width:30px;filter: invert(0.5) sepia(1) saturate(5) hue-rotate(-608deg);height:25px"  /><b>&nbsp;</b> {{tabs[1]}}
                </template>
              <pdentry></pdentry>
              </CTab>
          
            </CTabs>
</CCardBody>
</CCard>
</template>

<script>
import { APIService } from "../../../apiservice.js";
import CTableWrapper from "../../tables/Table";
import Locationmap from "@/components";
import Dropdown from "vue-simple-search-dropdown";
import { Vselect } from "@/components";
import Swal from "sweetalert2";
import FixedPlugin from "./animalFixedPlugin1.vue";
import pdentry from "../Breed/Milk/pdentry"
export default {
  components: { CTableWrapper, Locationmap, Vselect,FixedPlugin,pdentry },

  data() {
    return {
       tabs: [
        'Animal',
        'Service',
        
      ],
    };
  },
  methods: {
  }
};
</script>
